module.exports = __webpack_public_path__ + "c6c177a6e40913df7baa49dba308f631.png";